import moment from 'moment';

export const columns = [
  {
    Header: 'Date',
    accessor: 'OccurenceDT',
    sortable: true,
    sortMethod: (a, b) => {
      return moment(a) > moment(b) ? 1 : -1;
    },
  },
  {
    Header: 'App Member',
    accessor: 'AppMember',
    sortable: true,
  },
  {
    Header: 'Field Name',
    accessor: 'FieldName',
    sortable: true,
  },
  {
    Header: 'Old Value',
    accessor: 'OldValue',
    sortable: true,
  },
  {
    Header: 'New Value',
    accessor: 'NewValue',
    sortable: true,
  },
  {
    Header: 'User',
    accessor: 'LastModifiedBy',
    sortable: true,
  },
];

export const AppHistoryFilterEnum = {
  All: 'All',
  Household: 'H',
  Member: 'M',
  Student: 'S',
};

export const options = [
  { value: AppHistoryFilterEnum.All, label: 'All' },
  { value: AppHistoryFilterEnum.Household, label: 'Household' },
  { value: AppHistoryFilterEnum.Member, label: 'Member' },
  { value: AppHistoryFilterEnum.Student, label: 'Student' },
];



// WEBPACK FOOTER //
// ./src/pages/manageapplication/helpers/ApplicationHistoryObjects.js